import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { s as slotFilled } from './index3.js';
import { d as defineCustomElement$4 } from './box.js';
import { d as defineCustomElement$3 } from './icon.js';
import { d as defineCustomElement$2 } from './tooltip.js';
import { d as defineCustomElement$1 } from './tooltip-label.js';

const formFieldCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.25rem;height:100%;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;position:relative;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host([size=lg]) label>h3{color:var(--jw-theme-form-field-filled-color);font-family:Open Sans;font-size:1.125rem;font-weight:400;letter-spacing:-.0008em;line-height:1.5rem;margin:0}label{display:flex;flex-direction:column;gap:.25rem;height:100%;width:100%}.label{color:var(--jw-theme-form-label-color);display:flex;font-family:Open Sans;font-size:.875rem;font-weight:600;letter-spacing:-.0004em;line-height:1.25rem}.label span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.label .required-asterisk{color:var(--jw-theme-form-validation-error-color);margin-left:.125rem}.label .optional-text{color:var(--jw-theme-form-field-placeholder-color);font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;margin-left:.25rem}.label wui-tooltip{align-self:center;margin-left:.25rem}.description{color:var(--jw-theme-form-validation-default-color);display:flex;justify-content:space-between;margin-left:var(--form-field--description-left,0);transition:color .3s ease}.description span{font-family:Open Sans;font-size:.75rem;font-weight:400;letter-spacing:0;line-height:1rem}.description.error{color:var(--jw-theme-form-validation-error-color)}.description.warning{color:var(--jw-theme-form-validation-warning-color)}";
const WuiFormFieldStyle0 = formFieldCss;

const WuiFormField = /*@__PURE__*/ proxyCustomElement(class WuiFormField extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.label = undefined;
        this.description = undefined;
        this.helperText = undefined;
        this.tooltip = undefined;
        this.requisite = undefined;
        this.errorMessage = undefined;
        this.errorType = 'error';
        this.size = 'md';
        this.value = '';
        this.disabled = false;
    }
    renderDescription() {
        if (!(this.errorMessage || typeof this.description === 'string' || slotFilled(this.el, 'post-description'))) {
            return;
        }
        return (h("div", { class: `description${this.errorMessage && this.errorType ? ` ${this.errorType}` : ''}` }, h("wui-box", { align: "start", gutter: "2xs", orientation: "horizontal", justify: "center" }, this.errorMessage && (h("wui-icon", { name: this.errorType === 'error' ? 'alert-circle-filled' : 'alert-triangle-filled' })), h("span", null, this.errorMessage || (typeof this.description === 'string' ? this.description : ''))), h("slot", { name: "post-description" })));
    }
    render() {
        return (h(Host, { key: '2f7901682c28e243fade177630209e2577dbcd43' }, h("label", { key: '53970681bf8049273a71664031cb0ee722fd354b', "aria-hidden": !this.label }, typeof this.label === 'string' && (h("div", { key: 'e05aece2265b0dcf2ecb2c7f5b8a2abfd9b43569', class: "label" }, h("span", { key: 'c88381da26a62d1b606a8602e7d308aac05afae8' }, this.label || '\u200B'), this.requisite === 'required' && h("span", { key: 'df32beb73f08022d365677efc096d56d6e40e59e', class: "required-asterisk" }, "*"), this.requisite === 'optional' && h("span", { key: '51c06405534966126bb6cca81fcd8a3e9d5e63e8', class: "optional-text" }, "(Optional)"), this.tooltip && (h("wui-tooltip", { key: 'f4dbd406a3ce2f12556c74aef8c895ad4ef10eab', label: this.tooltip }, h("wui-icon", { key: 'eed88f7e97bee52daec3f8759ea92281dbe24180', name: "help-filled" }))))), this.helperText && (h("div", { key: '2c35c1f9cec2a1ae1afb4bae3c329d9a5862b3f6', class: "description" }, h("wui-box", { key: 'ee2dfef7046e155513236db03ecd6f3f04226ce7', align: "start", gutter: "2xs", orientation: "horizontal", justify: "center" }, h("span", { key: '29c774475918d0bbc88a20133bfa1c3c82129090' }, this.helperText)))), this.size === 'lg' ? h("h3", null, this.value) : h("slot", null)), this.renderDescription()));
    }
    get el() { return this; }
    static get style() { return WuiFormFieldStyle0; }
}, [1, "wui-form-field", {
        "label": [1],
        "description": [1],
        "helperText": [1, "helper-text"],
        "tooltip": [1],
        "requisite": [1],
        "errorMessage": [1, "error-message"],
        "errorType": [1, "error-type"],
        "size": [513],
        "value": [1],
        "disabled": [516]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-form-field", "wui-box", "wui-icon", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiFormField);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiFormField as W, defineCustomElement as d };

//# sourceMappingURL=form-field.js.map